module.exports = __webpack_public_path__ + "img/arrow-green-up.96fe9903.svg";